import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import PromoCodeForm from './PromoCodeForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class PromoCodeDialog extends Component {
	dialogConfig() {
		const { t, onCancel } = this.props;

		return {
			header: t('PaymentHistory_PromoCode_Add'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm } = this.props;
		return <PromoCodeForm onSubmit={onConfirm} />;
	}

	renderFooter() {
		const { onCancel, newPromoCode, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='applyPromoCode'
			label={t('PaymentHistory_PromoCode_Apply')}
			disabled={!newPromoCode} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
	}
}

PromoCodeDialog.propTypes = {
	show: PropTypes.bool,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(PromoCodeDialog);